import { RootState } from "@store/rootReducer"

export const selectErrors = (state: RootState) => state.feedback.errors
export const selectNotification = (state: RootState) => state.feedback.notification
